import React, { ReactNode, useState } from 'react';
import FirstLoader from '@components/main/first-loader';
import SessionProvider from '@context/sessionProvider';
import { SettingsProvider } from '@context/settingsProvider';
import { ReloadIframeProvider } from '@context/iframeProvider';
import ErrorPage from '@components/main/error';
import { AmplitudeProvider } from '@/amplitude/amplitudeContext';
import { useRouter } from 'next/router';

interface CombinedProviderProps {
	children: ReactNode;
	initialContext: string;
}

const CombinedProvider: React.FC<CombinedProviderProps> = ({ children, initialContext }) => {
	const { query } = useRouter();
	const { tid } = query;
	const [isSessionLoaded, setSessionLoaded] = useState(false);
	const [isSettingsLoaded, setSettingsLoaded] = useState(false);
	const [isAmplitudeLoaded, setAmplitudeLoaded] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const isLoading = !isSessionLoaded || !isSettingsLoaded || !isAmplitudeLoaded;

	const handleError = (message: string) => {
		setError(message);
	};

	if (error) {
		return <ErrorPage error={error} />;
	}

	return (
		<>
			<SessionProvider initialContext={initialContext} onLoad={() => setSessionLoaded(true)} onError={handleError}>
				<SettingsProvider tid={tid as string} onLoad={() => setSettingsLoaded(true)} onError={handleError}>
					<AmplitudeProvider onLoad={() => setAmplitudeLoaded(true)} onError={handleError}>
						<ReloadIframeProvider>{!isLoading && children}</ReloadIframeProvider>
					</AmplitudeProvider>
				</SettingsProvider>
			</SessionProvider>
			{isLoading && <FirstLoader />}
		</>
	);
};

export default CombinedProvider;
